import { render } from "./sys-detail.vue?vue&type=template&id=1d4a2e12&scoped=true"
import script from "./sys-detail.vue?vue&type=script&lang=js"
export * from "./sys-detail.vue?vue&type=script&lang=js"

import "./sys-detail.vue?vue&type=style&index=0&id=1d4a2e12&lang=scss&scoped=true"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4a2e12"]])

export default __exports__